import React, { useState, useEffect } from 'react';
import { View, Image, Text, StyleSheet, ScrollView, TextInput } from 'react-native';
import axios from 'axios';
import Hyperlink from 'react-native-hyperlink'
import colors from '../config/colors';
import he from 'he';

const OpenGrphStractor = ({ url, typePresentation }) => {
  const [urlText, setUrlText] = useState('')
  const [ogDataTitle, setOgDataTitle] = useState('\u{1F60A}');
  const [ogDataImage, setOgDataImage] = useState(null);
  const [titleBoxText, setTitleBoxText] = useState('')
  const [errorAxios, setErrorAxios] = useState(false)//valida si hubo un error con axios 
  useEffect(() => {
    const fetchOpenGraphData = async () => {
      try {
        console.log("----------> mmmmmm", url);
        debugger
        //--------------------------------------------------------------
        const proxyUrl = `https://api.allorigins.win/raw?url=${url}`;
        const response = await axios.get(proxyUrl);
           //debugger
        console.log(response.data.includes('og:image'), ' response -------------------', response.data.length)
        if (url.includes('www.facebook')) {
          console.log("----------> Sunday facebook");
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('" />')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew  del face  ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola', urlNew.substr(posIni, posFin))

          //setOgDataImage(urlNew);
          setOgDataImage('https://www.facebook.com/images/fb_icon_325x325.png')
          //setOgDataTitle(newTitle);
          setOgDataTitle('Facebook');
        } else if (url.includes('www.instagram')) {
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
       
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('" />')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          // console.log('ini   ', posIni)
          // console.log('fin   ', posFin)
          // console.log('urlnew    ', urlNew)
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)
          //-----------------------------------------rapado
          newTitle = he.decode(newTitle)
          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          //console.log('hola', urlNew.substr(posIni, posFin))
          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://x.com')) {
          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://www.tiktok.')) {
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------

          var posIniTitle = response.data.indexOf('og:description')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('</title>')
          newTitle = response.data.substr(posIniTitle, 500)

          console.log('lengt -----------  2', response.data.length)
          console.log('iniTitle -----------  1', posIniTitle)
          console.log('finTitle -----  1', posFinTitle)
          console.log('newTitle  --------  1', newTitle)

          setOgDataImage('https://www.tiktok.com/favicon.ico')
        }
        else if (url.includes('https://vm.tiktok')) {
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------

          var posIniTitle = response.data.indexOf('cache')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('</title>')
          newTitle = response.data.substr(posIniTitle, 50)

          console.log('lengt -----------  1', response.data.length)
          console.log('iniTitle -----------  1', posIniTitle)
          console.log('finTitle -----  1', posFinTitle)
          console.log('newTitle  --------  1', newTitle)
          setOgDataImage('https://www.tiktok.com/favicon.ico')
        }
        else if (url.includes('https://youtu.be/')) {
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('">')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          // urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew  de yout  ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('">')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);

        } else if (url.includes('https://articulo.mercadolibre')) {
          console.log('mercado libre  ')
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('"/>')
          //urlNew = response.data.substr(posIni, posFin)
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew  de mercado  ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('"/>')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://www.amazon')) {
          console.log('mercado https://www.amazon ')
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          // var posIni = response.data.indexOf('og:image" content=')
          // var urlNew = response.data.substr(posIni)
          // var posFin = urlNew.indexOf('"/>')
          // urlNew = response.data.substr(posIni + 19, posFin - 19)
          // urlNew = urlNew.replaceAll('&amp;', '&')

          // console.log('ini   ', posIni)
          // console.log('fin   ', posFin)
          // console.log('urlnew    ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          // var posIniTitle = response.data.indexOf('og:title" content=')
          // var newTitle = response.data.substr(posIniTitle)
          // var posFinTitle = newTitle.indexOf('"/>')
          // newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          // console.log('iniTitle   ', posIniTitle)
          // console.log('finTitle   ', posFinTitle)
          // console.log('posFinTitle    ', newTitle)

          // console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqIWWWzfybKZT_Tgg7ABHIyGX_KzQXAwW_PslAY6MMGzbuoesuUXjGNeLhdKleso5OKw&usqp=CAU');
          setOgDataTitle('Amazon');
        }
        else if (url.includes('https://a.aliexpress.com')) {
          console.log('mercado a.aliexpress.com ------ ')
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('"/>')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew  de alliiiiiii  ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          // console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        }
        else if (url.includes('https://www.reddit.com/')) {
          setOgDataImage('https://pipedream.com/s.v0/app_mo7hbd/logo/orig');
          setOgDataTitle('Redit');
        }

        else {
          //-----------------------------------------------------------------
          //*en el caso de no caer en una red social *
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('" />')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew  del else  ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola soy el else OpendGraph')

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);

        }
      } catch (error) {
        setErrorAxios(true)
        console.error('Error fetching Open Graph data:', error);
      }
    };

    if (typePresentation === 'withoutInput') {
      console.log('ejemplo de ->')
      if (url) fetchOpenGraphData()
    } else if (typePresentation === 'input') {
      if (url) fetchOpenGraphDataInput(url);
    } else {
      if (url) fetchOpenGraphData()
    }
  }, []);

  //------------------------------------------
  //Funcion que se activa con Input
  //------------------------------------------
  const fetchOpenGraphDataInput = async (url) => {
    if (url == ! '') {
      try {
        //--------------------------------------------------------------
        const response = await axios.get(url);
        if (url.includes('www.facebook')) {
          console.log("----------> Sunday facebook");
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('" />')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew    ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola', urlNew.substr(posIni, posFin))

          //setOgDataImage(urlNew);
          setOgDataImage('https://www.facebook.com/images/fb_icon_325x325.png')
          //setOgDataTitle(newTitle);
          setOgDataTitle('Facebook');
        } else if (url.includes('www.instagram')) {
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('" />')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          // console.log('ini   ', posIni)
          // console.log('fin   ', posFin)
          // console.log('urlnew    ', urlNew)
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://x.com')) {
          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://www.tiktok.')) {
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------

          var posIniTitle = response.data.indexOf('og:description')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('</title>')
          newTitle = response.data.substr(posIniTitle, 500)

          console.log('lengt -----------  2', response.data.length)
          console.log('iniTitle -----------  1', posIniTitle)
          console.log('finTitle -----  1', posFinTitle)
          console.log('newTitle  --------  1', newTitle)

          setOgDataImage('https://www.tiktok.com/favicon.ico')
        }
        else if (url.includes('https://vm.tiktok')) {
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------

          var posIniTitle = response.data.indexOf('cache')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('</title>')
          newTitle = response.data.substr(posIniTitle, 50)

          console.log('lengt -----------  1', response.data.length)
          console.log('iniTitle -----------  1', posIniTitle)
          console.log('finTitle -----  1', posFinTitle)
          console.log('newTitle  --------  1', newTitle)
          setOgDataImage('https://www.tiktok.com/favicon.ico')
        }
        else if (url.includes('https://youtu.be/')) {
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('">')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          // urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew    ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('">')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);

        } else if (url.includes('https://articulo.mercadolibre')) {
          console.log('mercado libre  ')
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('"/>')
          //urlNew = response.data.substr(posIni, posFin)
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')

          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew    ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('"/>')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)

          console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);
        } else if (url.includes('https://www.amazon' || 'https://a.co/')) {
          console.log('mercado https://www.amazon ')
          //-----------------------------------------------------------------
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          // var posIni = response.data.indexOf('og:image" content=')
          // var urlNew = response.data.substr(posIni)
          // var posFin = urlNew.indexOf('"/>')
          // urlNew = response.data.substr(posIni + 19, posFin - 19)
          // urlNew = urlNew.replaceAll('&amp;', '&')

          // console.log('ini   ', posIni)
          // console.log('fin   ', posFin)
          // console.log('urlnew    ', urlNew)

          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          // var posIniTitle = response.data.indexOf('og:title" content=')
          // var newTitle = response.data.substr(posIniTitle)
          // var posFinTitle = newTitle.indexOf('"/>')
          // newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          // console.log('iniTitle   ', posIniTitle)
          // console.log('finTitle   ', posFinTitle)
          // console.log('posFinTitle    ', newTitle)

          // console.log('hola', urlNew.substr(posIni, posFin))

          setOgDataImage('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqIWWWzfybKZT_Tgg7ABHIyGX_KzQXAwW_PslAY6MMGzbuoesuUXjGNeLhdKleso5OKw&usqp=CAU');
          setOgDataTitle('Amazon');
        }
        else {
          //-----------------------------------------------------------------
          //*en el caso de no caer en una red social *
          //Rutina que limpia la url de un open graph para extraer la imagen
          //-----------------------------------------------------------------
          var posIni = response.data.indexOf('og:image" content=')
          var urlNew = response.data.substr(posIni)
          var posFin = urlNew.indexOf('"/>')
          urlNew = response.data.substr(posIni + 19, posFin - 19)
          urlNew = urlNew.replaceAll('&amp;', '&')
          urlNew = urlNew.replaceAll('"/>', '')
          //urlNew - 3
          console.log('ini   ', posIni)
          console.log('fin   ', posFin)
          console.log('urlnew del else   ', urlNew)
          // if (urlNew.includes('"/>')) {
          //   urlNew + 3
          //   console.log('sppppppppppppppppppppppp' + urlNew)
          // }
          //-----------------------------------------------------------------
          //Rutina que limpia el estring de un open graph para extraer el titulo
          //-----------------------------------------------------------------
          var posIniTitle = response.data.indexOf('og:title" content=')
          var newTitle = response.data.substr(posIniTitle)
          var posFinTitle = newTitle.indexOf('" />')
          newTitle = response.data.substr(posIniTitle + 19, posFinTitle - 19)

          console.log('iniTitle   ', posIniTitle)
          console.log('finTitle   ', posFinTitle)
          console.log('posFinTitle    ', newTitle)


          console.log('hola soy el else OpendGraph')

          setOgDataImage(urlNew);
          setOgDataTitle(newTitle);

        }
      } catch (error) {
        setErrorAxios(true)
        // console.error('Error fetching Open Graph data:', error);
      }
    }
  };

  const onChangeTextUrlDetect = (text) => {
    setTitleBoxText(text)
    if (text.includes('https://')) {

      text + ' '
      console.log('https:// si entre' + text + 'x')
      var posIni = text.indexOf('https://')
      var urlNew = text.substr(posIni)
      var posFin = urlNew.indexOf(' ')
      urlNew = text.substr(posIni, posFin)
      console.log('urlNew ..... del Input' + urlNew)
      setUrlText(urlNew)
      fetchOpenGraphData(urlNew)
      // urlNew = urlNew.replaceAll('&amp;', '&')
    }
  }
  //var em = '¡Hola! \u{1f528}\u{1F31F}\u{1F389} esc  \u{1f528}'
  // var em = ogDataTitle
  //String(em)
  // const [listing, setlisting] = useState(' &#064}healthesencia on Instagram: &quot} \u{1f33f} Descubre por qu \u{e9} la planta de serpiente  \u{1f40d} es imprescindible en tu habitaci \u{f3}n seg \u{fa}n un m \u{e9}dico japon \u{e9}s!  \u{1f1ef} \u{1f1f5} Desde purificar el aire hasta mejorar tu sue \u{f1}o, esta planta tiene incre \u{ed}bles beneficios.  \u{1f4a4} No te pierdas las seis razones que te revelamos en este v \u{ed}deo.  \u{a1}Prep \u{e1}rate para sorprenderte!  \u{2728} #plantadeserpiente #airepuro #dormirmejor #saludnatural #cuidadodeplantas #bienestar #plantasencasa #ecoamigable #h \u{e1}bitossaludables #jardiner \u{ed}a #consejosdesalud #vidasostenible #medioambiente #bienestaremocional #hogarverde  \u{1f331}&quot}') // para que es 
  //const [listing, setlisting] = useState(em) // para que es 
  var em = ' &#064;healthesencia on Instagram: &quot;&#x1f33f; Descubre por qu&#xe9; la planta de serpiente &#x1f40d; es imprescindible en tu habitaci&#xf3;n seg&#xfa;n un m&#xe9;dico japon&#xe9;s! &#x1f1ef;&#x1f1f5; Desde purificar el aire hasta mejorar tu sue&#xf1;o, esta planta tiene incre&#xed;bles beneficios. &#x1f4a4; No te pierdas las seis razones que te revelamos en este v&#xed;deo. &#xa1;Prep&#xe1;rate para sorprenderte! &#x2728; #plantadeserpiente #airepuro #dormirmejor #saludnatural #cuidadodeplantas #bienestar #plantasencasa #ecoamigable #h&#xe1;bitossaludables #jardiner&#xed;a #consejosdesalud #vidasostenible #medioambiente #bienestaremocional #hogarverde &#x1f331;'
  return (
    <>
      {
        errorAxios === false ?
          <>
            {
              //.............................................
              //Sección que pinta opción con input
              //.............................................
              typePresentation === 'input' ?
                <>
                  {
                    urlText === '' ?
                      null
                      :
                      <View style={styles.allContent}>
                        <View style={styles.imgContent}>
                          <Image resizeMode="contain" source={{ uri: ogDataImage }} style={styles.image} />
                        </View>
                        <Hyperlink linkStyle={{
                          color: '#2980b9',
                          textDecorationLine: 'underline'
                        }}
                          linkDefault={true}
                        >
                          <Text style={styles.title}>{url}</Text>
                        </Hyperlink>
                        <Text style={styles.title}>{ogDataTitle}</Text>
                      </View>
                  }
                  <TextInput style={styles.input}
                    onChangeText={text => onChangeTextUrlDetect(text)}
                    placeholder={"	Da click para anotar un título"}
                    value={titleBoxText}
                    multiline={true}
                    maxLength={499}
                  //scrollEnabled = {true}
                  />
                </>
                : typePresentation === 'withoutInput' ?
                  <View style={styles.allContent}>
                    <View style={styles.imgContent}>
                      <Image resizeMode="contain" source={{ uri: ogDataImage }} style={styles.image} />
                    </View>
                    <View style={styles.containerTitle}>
                      <Text style={styles.title}>{ogDataTitle}</Text>
                      <Text style={styles.title}>{url}</Text>
                    </View>
                  </View>
                  :
                  <View
                  //style={styles.cont}
                  >
                    {url && (
                      <View style={styles.allContBig}>
                        <Text style={styles.titleBig}>{ogDataTitle
                        }</Text>

                        <View style={styles.imgContentBig}>
                          {
                            ogDataImage && (
                              <Image resizeMode="contain" source={{ uri: ogDataImage }} style={styles.image} />
                            )
                          }
                        </View>
                        <View style={{ width: '85%', }}>
                          <Hyperlink linkStyle={{
                            width: '85%',
                            color: '#2980b9',
                            textDecorationLine: 'underline'
                          }}
                            linkDefault={true}
                          >
                            <Text style={styles.titleBig}>{url}</Text>
                          </Hyperlink>
                        </View>
                      </View>
                    )}
                  </View>
            }
          </>
          :
          <Text style={styles.titleBig}>error :v </Text>
      }
    </>
  );
};

const styles = StyleSheet.create({

  titleBig: {
    marginTop: '3%',
    width: '85%',
    color: colors.medium,
    fontSize: 12,
    fontWeight: 'bold',
    // justifyContent: 'center'
    // backgroundColor: 'red'
  },
  allContBig: {
    backgroundColor: colors.fondoInput,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    width: '100%',
    //flexDirection: 'row'
  },
  allContent: {
    backgroundColor: colors.fondoInput,
    justifyContent: 'center',
    borderRadius: 20,
    width: '100%',
    flexDirection: 'row'
  },
  input: {
    backgroundColor: colors.fondoInput,
    borderWidth: 2,
    borderColor: colors.fondoImagenes,
    paddingLeft: 5,
    borderRadius: 25,
    width: "80%",
  },
  // input: {
  //   width: '100%',
  //   height: 100,
  //   backgroundColor: 'red'
  // },
  cont: {
    //  width: 200,
    height: 100,

  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgContentBig: {
    // alignContent
    width: 150,
    height: 150,
    borderRadius: 20,
    backgroundColor: colors.fondoInput
  },
  imgContent: {
    width: 80,
    height: 80,
    // marginRight: 10,
    //marginBottom: 10,
    //borderRadius: 25,
    borderRadius: 20,
    backgroundColor: colors.fondoInput
    // alignSelf: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  containerTitle: {
    width: '70%',
    alignSelf: 'center',
  },
  title: {
    // width: '70%',
    justifyContent: 'center',
    alignSelf: 'center',
    fontSize: 9,
    fontWeight: 'bold',
  },
});

export default OpenGrphStractor;